import styled from 'styled-components'
import { ContainerSombra } from '../../../../components/ContainerSombra'

export const opsEmAbertoResumoStyle = {
  Container: styled(ContainerSombra)`
    padding: 24px;
    margin-bottom: 16px;
  `,
  ContainerValorQuantidade: styled.div`
    margin: 24px 0px;
    display: flex;
    align-items: center;
    flex-direction: column;
  `
}
